import Link from "next/link";
import type { ComponentProps } from "react";
import Text from "@src/lib/ui/Text";

type HomeSectionProps = {
  children: React.ReactNode;
  title: string;
  /** When set, the section title is a link (e.g. to a full list view). */
  titleHref?: ComponentProps<typeof Link>["href"];
};

export const HomeSection = ({
  children,
  title,
  titleHref,
}: HomeSectionProps): React.ReactElement => {
  const titleNode = <Text variant="body-title">{title}</Text>;

  return (
    <div className="flex flex-col gap-4">
      {titleHref ? (
        <Link
          href={titleHref}
          className="w-fit rounded-sm no-underline transition-colors outline-none hover:underline focus-visible:ring-2 focus-visible:ring-blue-4 focus-visible:ring-offset-2"
        >
          {titleNode}
        </Link>
      ) : (
        titleNode
      )}
      {children}
    </div>
  );
};
